module.exports = __webpack_public_path__ + "static/img/red_limi_1.2b868cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/pk/red_limi_1.png
// module id = JD3c
// module chunks = 1